import React, { memo } from 'react';
import classNames from 'classnames';
import cls from './EmptyTasks.module.css';
import { TasksBlockType } from '../../model/taskBoard';
import { Tabs } from 'entities/task/model/types/tasksInformationSchema';
import { useAppSelector } from '../../../../store';
import { useTranslation, Trans } from 'react-i18next';

interface EmptyTasksProps {
    classes?: string;
    type: TasksBlockType;
    filteredTabs: Tabs | null;
}

export const EmptyTasks = memo(({ classes, type, filteredTabs }: EmptyTasksProps) => {
    const { t } = useTranslation();

    const emptyContentMapping = {
        [TasksBlockType.OVERDUE]: (
            <span>
                <Trans i18nKey={'EmptyTasks.emptyContentMapping.TasksBlockType.OVERDUE'} />
            </span>
        ),
        [TasksBlockType.IN_PROCESS]: (
            <span>
                <Trans i18nKey={'EmptyTasks.emptyContentMapping.TasksBlockType.IN_PROCESS'} />
            </span>
        ),
        [TasksBlockType.NO_TERM]: (
            <span>
                <Trans i18nKey={'EmptyTasks.emptyContentMapping.TasksBlockType.NO_TERM'} />
            </span>
        ),
        [TasksBlockType.TODAY]: (
            <span>
                <Trans i18nKey={'EmptyTasks.emptyContentMapping.TasksBlockType.TODAY'} />
            </span>
        ),
        [TasksBlockType.IN_WEEKS]: (
            <span>
                <Trans i18nKey={'EmptyTasks.emptyContentMapping.TasksBlockType.IN_WEEKS'} />
            </span>
        ),
    };

    const { isFiltered } = useAppSelector((state) => state.tasksInformationReducer);

    return (
        <div className={classNames(cls.EmptyTasks, [classes], cls[type])}>
            {!isFiltered ? (
                emptyContentMapping[type]
            ) : (
                <div className={classNames(cls.EmptyTasks, cls[type])}>
                    {t('EmptyTasks.return.not_found_tasks')}
                </div>
            )}
        </div>
    );
});
